<div class="reply-node" [ngClass]="{'has-children': reply.replies?.length > 0}">
  <div class="reply-container">
    <div class="profile-section-wrapper">
      <div class="horizontal-line">


      </div>
      <!-- Show only for child replies -->
      <!-- <div class="curved-connector">
        <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0 C 20 0, 20 20, 40 20" stroke="#ccc" stroke-width="2" fill="none" />
        </svg>
      </div> -->


      <div class="profile-section" style="flex-shrink: 0;">
        <img *ngIf="reply?.dental_practice" class="profile-image"
          [src]="reply.dental_practice?.profile_image?.url || reply?.dental_practice?.logo?.url" />
        <img *ngIf="reply?.dental_professional" class="profile-image"
          [src]="reply.dental_professional?.profile_image?.url || reply?.dental_professional?.logo?.url" />
        <img *ngIf="reply?.dental_supplier" class="profile-image"
          [src]="reply.dental_supplier?.profile_image?.url || reply?.dental_supplier?.logo?.url" />
        <img *ngIf="reply?.admin_user" src="../../../../../assets/images/logo.svg" class="profile-image"
          alt="Admin Icon" />
      </div>
    </div>

    <div class="reply-navbar">

      <div style="flex-grow: 1;">

        <div class="reply-header" style="display: flex;">
          <span class="replier-name">{{ reply?.dental_practice?.name || reply?.dental_professional?.name ||
            reply?.dental_supplier?.name || reply?.admin_user?.name }}</span>

          <div class="comment-actions-and-menu">

            <span class="comment-date">
              <span> {{reply?.created_at | date: 'MMM d y'}} </span>
            </span>

            <div *ngIf="canEditOrDelete(reply)">
              <div mat-icon-button [matMenuTriggerFor]="feedMenuPending" aria-label="More options" class="matRoundIco"
                style="cursor: pointer;">
                <mat-icon class="action-button">more_horiz</mat-icon>
              </div>
              <mat-menu #feedMenuPending="matMenu">
                <button mat-menu-item *ngIf="isReplyOwner(reply)" (click)="editReply(reply)">
                  <mat-icon>edit</mat-icon>
                  <span>Edit</span>
                </button>
                <button mat-menu-item *ngIf="isReplyOwner(reply) || isAdmin()" (click)="deleteReply(reply)">
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>
            </div>
          </div>

        </div>

        <div class="reply-content">
          {{ reply.reply_text }}
        </div>

        <div *ngIf="reply?.reply_attachments?.length > 0" class="image-preview-container">

          <div *ngFor="let replyAttach of reply?.reply_attachments; let i = index"
            (click)="viewcommentDocuments(reply?.reply_attachments, i)" class="preview-wrapper">

            <img *ngIf="replyAttach?.type?.startsWith('image/')" [src]="replyAttach.url" class="preview-image">

            <div *ngIf="replyAttach?.type === 'application/pdf'">
              <img class="preview-image" src="../../../../../assets/images/file_icons/pdf.svg">
            </div>

            <div
              *ngIf="replyAttach?.type === 'application/msword' || replyAttach?.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'">
              <img class="preview-image" src="../../../../../assets/images/file_icons/doc.svg">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="reply-btn" style="margin-left: auto;" (click)="toggleReplyed(reply)">
    Reply
  </div>


  <div class="nested-replies" *ngIf="reply.replies?.length" style="padding-left: 64px;">

    <app-reply *ngFor="let nestedReply of reply.replies; let j = index" [reply]="nestedReply"
      [commentIndex]="commentIndex" [level]="level + 1" [isLast]="j === reply.replies.length - 1"
      (replyClicked)="replyClicked.emit($event) " (feedStatusChanged)="handleFeedStatusChange($event)"  (getCommentsReply)="onGetCommentsReplyFromNested($event)" >
    </app-reply>

  </div>

</div>